export enum Locale {
  IN = 'in',
  US = 'us',
  CRYPTO = 'crypto',
};

export enum SegmentConfig {
  equity = 'equity',
  future = 'future',
  option = 'option',
}
